import { render, staticRenderFns } from "./jiben.vue?vue&type=template&id=0e3bff39&scoped=true&"
import script from "./jiben.vue?vue&type=script&lang=js&"
export * from "./jiben.vue?vue&type=script&lang=js&"
import style0 from "./jiben.vue?vue&type=style&index=0&id=0e3bff39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3bff39",
  null
  
)

export default component.exports